import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const ContactInfo = () => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-md">
      <h3 className="text-2xl font-semibold text-gray-900 mb-6 font-display">
        Contact Information
      </h3>

      <div className="space-y-6">
        <div className="flex items-start">
          <Phone
            size={20}
            className="text-psa-green-600 mt-1 mr-4 flex-shrink-0"
          />
          <div>
            <h4 className="font-medium text-gray-900 mb-1">Phone Numbers</h4>
            <p className="text-gray-600">+88 01710-908697</p>
            <p className="text-gray-600">+88 018132-27053</p>
          </div>
        </div>

        <div className="flex items-start">
          <Mail
            size={20}
            className="text-psa-green-600 mt-1 mr-4 flex-shrink-0"
          />
          <div>
            <h4 className="font-medium text-gray-900 mb-1">Email Address</h4>
            <p className="text-gray-600">miahmasum04@gmail.com</p>
            <p className="text-gray-600">psa34634@gmail.com</p>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6">
          <h4 className="font-medium text-gray-900 mb-3">Office Locations</h4>

          <div className="space-y-6 mt-4">
            <div className="flex items-start">
              <MapPin
                size={20}
                className="text-psa-green-600 mt-1 mr-4 flex-shrink-0"
              />
              <div>
                <h5 className="font-medium text-gray-900 mb-1">Chamber-1</h5>
                <p className="text-gray-600">
                  888/1, Haji Ashraf Ali Super Market
                </p>
                <p className="text-gray-600">East Shewrapara-Mirpur</p>
                <p className="text-gray-600">Dhaka-1216</p>
              </div>
            </div>

            <div className="flex items-start">
              <MapPin
                size={20}
                className="text-psa-green-600 mt-1 mr-4 flex-shrink-0"
              />
              <div>
                <h5 className="font-medium text-gray-900 mb-1">Chamber-2</h5>
                <p className="text-gray-600">Room # 11, (3rd Floor)</p>
                <p className="text-gray-600">74 Bhuiyan Mension, Kakrail</p>
                <p className="text-gray-600">Dhaka-1000</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex items-start">
          <Clock
            size={20}
            className="text-psa-green-600 mt-1 mr-4 flex-shrink-0"
          />
          <div>
            <h4 className="font-medium text-gray-900 mb-1">Business Hours</h4>
            <p className="text-gray-600">
              Sunday - Thursday: 9:00 AM - 6:00 PM
            </p>
            <p className="text-gray-600">Friday: Closed</p>
            <p className="text-gray-600">Saturday: 10:00 AM - 4:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
